/** */
import { urls } from '../_url';
import { apiGet, apiPost } from '../_http';

/** */
const base_url = `${urls.ai}/v1/reports`;

export const fetchPulseLine = async (options = {}) => {
  return await apiGet(`${base_url}/pulse`, { ...options });
};

export const fetchSuggestions = async (options = {}) => {
  return await apiGet(`${base_url}/suggestions`, { ...options });
};

export const fetchChartExplain = async (options = {}) => {
  return await apiPost(`${base_url}/chart-explain`, { ...options });
};
